import type { ReactNode } from 'react';
import type { TabType } from './TabBar';

interface TabContentProps {
  activeTab: TabType;
  chatView: ReactNode;
  filesView: ReactNode;
  youView: ReactNode;
}

export function TabContent({ activeTab, chatView, filesView, youView }: TabContentProps) {
  return (
    <div className="flex-1 overflow-hidden">
      {activeTab === 'chat' && chatView}
      {activeTab === 'files' && filesView}
      {activeTab === 'you' && youView}
    </div>
  );
}
